export default __webpack_public_path__ + "static/media/oval.165c054b.webp";